<template>
  <li class="activity-line-item">
    <span class="activity-icon">
      <i class="icon" :class="activityClassObject"></i>
    </span>
    <span class="activity-message">
      <span v-if="activity.subject_type === 'App\\Contact'">
        <router-link
          v-if="(activity && activity.subject) && !activity.subject.deleted_at"
          :to="'/a/contact/' + activity.subject.id">{{ activity.subject.name }}</router-link>
        <span v-if="activity && activity.subject && activity.subject.deleted_at">
          {{ activity.subject.name }}
        </span>
      </span>
      <span v-if="activity.subject_type === 'App\\User'">
        {{ activity.subject.name }}
      </span>

      <span v-if="activity.action === 'sent document'">{{ $t('activity.actions.sent_proposal') }}</span>
      <span v-else>{{ $t('activity.actions.' + activity.action) }}</span>

      <span v-if="activity.direct_object_type === 'App\\Document'">
        <router-link
          v-if="(activity && activity.direct_object) && !activity.direct_object.deleted_at"
          :to="'/a/document/' + activity.direct_object.id">{{ activity.direct_object.title }}</router-link>
        <span v-if="activity && activity.direct_object && activity.direct_object.deleted_at">
          {{ activity.direct_object.title }}
        </span>
      </span>

      <span v-if="activity.direct_object_type === 'App\\Contact'">
        {{ $t('activity.contact') }}
        <router-link
          v-if="(activity && activity.direct_object) && !activity.direct_object.deleted_at"
          :to="'/a/contact/' + activity.direct_object.id">{{ activity.direct_object.name }}</router-link>
        <span v-if="activity && activity.direct_object && activity.direct_object.deleted_at">
          {{ activity.direct_object.name }}
        </span>
      </span>
      {{ updated_at | utcFromNow }}
      <blockquote v-if="activity.notes" v-html="activity.notes"></blockquote>
    </span>
  </li>
</template>

<script>
  import { utcTimeZones } from 'mixins/time';

  export default {
    mixins: [utcTimeZones],
    props: ['activity'],
    computed: {
      activityClassObject() {
        return {
          'icon-view': this.activity.action === 'viewed',
          'icon-doc-copy': this.activity.action === 'created',
          'icon-edit': this.activity.action === 'edited',
          'icon-signature': this.activity.action ===  'signed',
          'icon-trash': this.activity.action === 'deleted',
          'icon-chat': this.activity.action === 'commented' || this.activity.action === 'sent document',
        };
      },
      updated_at() {
        return moment.utc(this.activity.updated_at).local().format();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  li {
    position: relative;
    background: $white;
    box-shadow: 0 2px 13px 1px rgba(211, 215, 221, 0.50);
    border-radius: 5px;
    min-height: 60px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 1px solid $white;
    padding-left: 85px;

    span.activity-icon {
      position: absolute;
      height: 100%;
      font-size: 20px;
      width: 60px;
      text-align: center;
      color: $white;
      background: $purple;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      display: flex;
      align-items: center;
      flex-direction: column;
      left: 0;
      top: 0;
      vertical-align: middle;

      .icon {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        margin-left: -3px;
        margin-top: -2px;
      }
    }

    span.activity-message {
      padding: 20px 0;
      width: 100%;

      a {
        font-weight: 500;
      }

      i {
        display: block;
        margin-top: 10px;
      }
    }

    blockquote {
      font-style: italic;
      background: darken($eggshell, 2%);
      border-left: 10px solid $mutedblue;
      margin: 1.5em 20px 0 0;
      padding: 0.5em 10px;
      quotes: "\201C""\201D""\2018""\2019";
      border-radius: 2px;
    }

    &:hover {
      border-color: $green;

      span.icon-left {
        background: $green;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// activity-line-item.vue?333986b6